function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/*
 * @copyright Copyright (c) 2019 Julius Härtl <jus@bitgrid.net>
 *
 * @author Julius Härtl <jus@bitgrid.net>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
import { ListItem as TiptapListItem } from 'tiptap-extensions';
import { Plugin } from 'tiptap';
import { toggleList } from 'tiptap-commands';
import { findParentNode } from 'prosemirror-utils';
var TYPES = {
  BULLET: 0,
  CHECKBOX: 1
};

var getParentList = function getParentList(schema, selection) {
  return findParentNode(function (node) {
    return node.type === schema.nodes.list_item;
  })(selection);
};

var ListItem = /*#__PURE__*/function (_TiptapListItem) {
  _inherits(ListItem, _TiptapListItem);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(ListItem).apply(this, arguments));
  }

  _createClass(ListItem, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type,
          schema = _ref.schema;
      return {
        'bullet_list_item': function bullet_list_item() {
          return function (state, dispatch, view) {
            return toggleList(schema.nodes.bullet_list, type)(state, dispatch, view);
          };
        },
        'todo_item': function todo_item() {
          return function (state, dispatch, view) {
            var schema = state.schema;
            var selection = state.selection;
            var $from = selection.$from;
            var $to = selection.$to;
            var range = $from.blockRange($to);
            var tr = state.tr;
            var parentList = getParentList(schema, selection);

            if (typeof parentList === 'undefined') {
              toggleList(schema.nodes.bullet_list, type)(state, function (_transaction) {
                tr = _transaction;
              }, view);
              parentList = getParentList(schema, tr.selection);
            }

            if (!range || typeof parentList === 'undefined') {
              return false;
            }

            tr.setNodeMarkup(parentList.pos, schema.nodes.list_item, {
              type: parentList.node.attrs.type === TYPES.CHECKBOX ? TYPES.BULLET : TYPES.CHECKBOX
            });
            tr.scrollIntoView();

            if (dispatch) {
              dispatch(tr);
            }
          };
        }
      };
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        nested: true
      };
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        attrs: {
          done: {
            default: false
          },
          type: {
            default: TYPES.BULLET
          }
        },
        draggable: true,
        content: 'paragraph block*',
        toDOM: function toDOM(node) {
          if (node.attrs.type === TYPES.BULLET) {
            return ['li', 0];
          }

          var checkboxAttributes = {
            type: 'checkbox',
            class: 'checkbox'
          };

          if (node.attrs.done) {
            checkboxAttributes.checked = true;
          }

          return ['li', ['input', checkboxAttributes], ['label', {
            class: 'checkbox-label'
          }, ['div', {
            class: 'checkbox-wrapper'
          }, 0]]];
        },
        parseDOM: [{
          priority: 100,
          tag: 'li',
          getAttrs: function getAttrs(el) {
            var checkbox = el.querySelector('input[type=checkbox]');
            return {
              done: checkbox && checkbox.checked,
              type: checkbox ? TYPES.CHECKBOX : TYPES.BULLET
            };
          }
        }],
        toMarkdown: function toMarkdown(state, node) {
          if (node.attrs.type === TYPES.CHECKBOX) {
            state.write("[".concat(node.attrs.done ? 'x' : ' ', "] "));
          }

          state.renderContent(node);
        }
      };
    }
  }, {
    key: "plugins",
    get: function get() {
      return [new Plugin({
        props: {
          handleClick: function handleClick(view, pos, event) {
            var state = view.state;
            var schema = state.schema;
            var selection = state.selection;
            var $from = selection.$from;
            var $to = selection.$to;
            var range = $from.blockRange($to);

            if (!range) {
              return false;
            }

            var parentList = findParentNode(function (node) {
              return node.type === schema.nodes.list_item;
            })(selection);
            var isLabel = event.target.tagName.toLowerCase() === 'label';

            if (typeof parentList === 'undefined' || parentList.node.attrs.type !== TYPES.CHECKBOX || !isLabel) {
              return;
            }

            var tr = state.tr;
            tr.setNodeMarkup(parentList.pos, schema.nodes.list_item, {
              done: !parentList.node.attrs.done,
              type: TYPES.CHECKBOX
            });
            view.dispatch(tr);
          }
        }
      })];
    }
  }]);

  return ListItem;
}(TiptapListItem);

export { ListItem as default };